// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-341737ba]{min-width:1080px}.container .page-wrapper[data-v-341737ba]{padding-top:60px;padding-bottom:80px;margin:0 auto}", ""]);
// Exports
module.exports = exports;
